/* src/app/controls/copy-right/copy-right.component.css */
/*# sourceMappingURL=copy-right.component.css.map */
